export const examError = [
  {
    path: '/alterar-exames',
    name: 'service-desk-exams',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      header: {
        title: 'Alterar serviços',
      },
      body: {
        title: 'Altere seu agendamento no guichê ou nos canais de atendimento.',
        subtitle:
          'Retire uma senha para continuar seu atendimento com um de nossos atendentes ou altere seu agendamento em um dos canais de atendimento.',
        showSubtitleArea: false,
        btnLabel: 'Continuar atendimento',
        nextView: 'questions_step',
        config: {
          showName: false,
          showSubtitle: true,
          showSubtitleArea: true,
        },
      },
    },
  },
  {
    path: '/alterar-exames-atendimento-movel',
    name: 'service-desk-exams-mobile-service',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      header: {
        title: 'Alterar serviços',
      },
      body: {
        title: 'Nosso time fará todas as alterações necessárias.',
        iconComponent: 'MedicalRequestSvg',
        list: [
          'Caso você tenha enviado o pedido médico previamente nosso time irá rever o pedido médico e realizar os ajustes necessários.',
          'Caso você não tenha enviado previamente o pedido médico, o profissional irá confirmar e realizar os ajustes no dia do atendimento.',
        ],
        nextView: 'questions_step',
        btnLabel: 'Continuar',
        config: {
          showName: false,
          showSubtitle: false,
          showList: true,
          showSubtitleArea: true,
        },
      },
    },
  },
];
